import { render, staticRenderFns } from "./RetrievalQueryCard.vue?vue&type=template&id=1f8e4748&"
import script from "./RetrievalQueryCard.vue?vue&type=script&lang=ts&"
export * from "./RetrievalQueryCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports